import { render } from "./CarbonImpactChart.vue?vue&type=template&id=5b182517&scoped=true"
import script from "./CarbonImpactChart.vue?vue&type=script&lang=js"
export * from "./CarbonImpactChart.vue?vue&type=script&lang=js"

import "./CarbonImpactChart.vue?vue&type=style&index=0&id=5b182517&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b182517"]])

export default __exports__